module.exports = __webpack_public_path__ + "static/media/mockup-remedios-light.01411125.png";